import chroma from 'chroma-js';

const colors = {
    white: '#FFFFFF',
    black: '#202020',
    grayLight5X: '#FDFDFD',
    grayLight4X: '#FAFAFA',
    grayLight3X: '#F6F6F6',
    grayLight2X: '#E4E4E4',
    grayLightX: '#DEDEDE',
    grayLight: '#ABABAB',
    grayLighter: '#8D8D8D',
    gray: '#7E8088',
    grayDark: '#555758',
    grayDarker: '#4D4C4C',
    grayDarkX: '#3C3D41',
    grayDark2X: '#313131',
    blueLight3X: '#EBF8FF',
    blueLight2X: '#C5DFFB',
    blueLightX: '#8ABFFE',
    blueLight: '#37B8EF',
    blueBright: '#46AEF9',
    blue: '#4CAFE3',
    blueDark: '#379FD7',
    indigoLight: '#8EACFD',
    indigo: '#8F99F1',
    teal: '#9DE8ED',
    greenLightX: '#C9EBD3',
    greenLighter: 'rgba(83, 186, 113, 0.1)',
    greenLight: '#BDF5BC',
    green: '#A0E89F',
    greenBright: '#8FD672',
    greenDark: '#48BB78',
    greenDarker: '#7AB76B',
    greenDark2X: '#197B00',
    yellowLight: '#FBF2C4',
    yellow: '#FFE49F',
    yellowDark: '#CCAC15',
    orangeLight: '#F5C3A4',
    orangeDark: '#CB834D',
    orangeBright: '#FF7337',
    red: '#EA7E7E',
    redDark: '#F56565',
    redLight: '#FE9595',
    redLight2X: '#FFF1F2',
    pink: '#E9A7E2',
};

const semantic = {
    bgDark: colors.grayDarkX,
    bgLight: colors.white,
    textDark: colors.black,
    textLight: colors.white,
    textGrayOnLight: colors.gray,
    textGrayLightOnLight: colors.grayLight,
    textGrayOnDark: chroma(colors.white).alpha(0.5).hex(),
    textGrayLightOnDark: chroma(colors.white).alpha(0.4).hex(),
    border: colors.grayLight2X,
};

const typography = {
    fontSizes: {
        ['2xs']: 8,
        xs: 10,
        sm: 12,
        md: 14,
        lg: 16,
        lgr: 18,
        xl: 20,
        '2xl': 22,
        '3xl': 24,
        '4xl': 28,
        '5xl': 36,
        '6xl': 48,
        '7xl': 64,
        '8xl': 104,
    },
    fontWeights: {
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
    },
    letterSpacings: {
        tight: '-0.02em', // -2%
        normal: '0',
    },
} as const;

const styleguide = {
    colors,
    semantic,
    typography,
};

export default styleguide;
